module.exports = __webpack_public_path__ + "static/img/slalom.ca10306.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/neuro/slalom.png
// module id = 7sN+
// module chunks = 0